// Nombre de la tienda a partir de su código (MundoTotal «1014» o de comercio «HAZL0000004-01»).
// Mismo origen que Compras Financiadas (console/invoice-dashboard): GET /api/invoice-credit/shop -> { res: [{ code, name }] }.

/** Arma el mapa código -> nombre una sola vez. Ignora tiendas sin código o sin nombre. */
export function mapaNombresTienda(tiendas: any): Record<string, string> {
  const mapa: Record<string, string> = {};
  for (const t of Array.isArray(tiendas) ? tiendas : []) {
    const code = String(t?.code ?? '').trim();
    const name = String(t?.name ?? '').trim();
    if (code && name) mapa[code] = name;
  }
  return mapa;
}

/** Nombre de la tienda; si no se conoce, el mismo código (nunca vacío salvo que no haya código: ''). */
export function nombreTienda(mapa: any, codigo: any): string {
  const code = String(codigo ?? '').trim();
  if (!code) return '';
  return (mapa && mapa[code]) || code;
}

/** ¿Se encontró el nombre (distinto del código)? Para mostrar el código pequeño al lado solo entonces. */
export function tieneNombreTienda(mapa: any, codigo: any): boolean {
  const code = String(codigo ?? '').trim();
  return !!code && !!(mapa && mapa[code]) && mapa[code] !== code;
}
